import styleButton from './LogIn.module.scss';
import styleDropdown from '../ConnectWallet/ConnectWallet.module.scss';
import { useTranslation } from 'react-i18next';
import { useUltradeWallet } from '../../../../wallets/useUltradeWallet';
import { useAppSelector, useIsLoggedSelector } from '../../../../services/hooks.service';
import { addressFormate } from '../../../../_utils';
import { useActiveAccount } from '../../../../wallets/useActiveAccount';
import { useRef, useState } from 'react';
import { WalletTab } from '../WalletTab/WalletTab';
import { useOnClickOutside } from '../../../../hooks';
import classNames from 'classnames';
import { MaintenanceMode } from '../../../../interfaces';
import { useViewportInfo } from '../../../../hooks/useViewportInfo';
import { initialSystemMaintenanceState, useGetMaintenanceQuery } from '@ultrade/react-sdk';

export const LogIn = () => {
  const { t } = useTranslation();
  const walletTab = useRef<HTMLDivElement>();
  const { signInAndLogin, disconnect } = useUltradeWallet();
  const activeWallet = useActiveAccount();
  const isLogged = useIsLoggedSelector();
  const { mobileView } = useViewportInfo();

  const activeAddress = useAppSelector((state) => state.user.activeAddress);
  const mainAddress = useAppSelector((state) => state.user.mainAddress);
  // const m_mode = useAppSelector((state) => state.system.maintenance_mode);
  const { data: {maintenance_mode} = initialSystemMaintenanceState } = useGetMaintenanceQuery();
  const [walletSettings, setWalletSettings] = useState(false);

  useOnClickOutside(walletTab, () => setWalletSettings(false));

  const openWalletTab = () => (!activeAddress && mainAddress) && setWalletSettings(!walletSettings);

  const handleLogIn = () => {
    if (maintenance_mode === MaintenanceMode.Full) return;
    !activeWallet || activeWallet?.chain === null
      ? disconnect()
      : signInAndLogin()
  }

  return (
    <> {
      (isLogged)
        ? <div className={styleDropdown.wallet_cont} ref={walletTab}>
          <button data-testid="logged-as"
            onClick={openWalletTab}
            className={classNames(styleButton.main_wallet_info, {[styleButton.clickable_main_wallet]: !activeAddress && mainAddress})}
          > 
            {t("header.logged_as", {address: addressFormate(mainAddress, mobileView ? 3 : 6)})}
            <i aria-hidden="true" style={{marginLeft: 16}} className={walletSettings ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
          </button>
          <div className={ walletSettings ? styleDropdown.wallets_block : styleDropdown.wallets_block_none }>
            <WalletTab
              walletAddress={mainAddress}
              hideAssets={true}
              closeTab={setWalletSettings}
            />
          </div>
        </div>
        : <button data-testid="log-in" 
            disabled={maintenance_mode === MaintenanceMode.Full}
            className={styleButton.log_in} 
            onClick={handleLogIn}
          >
            { t("comman_word.log_in") }
        </button>
    }</>
  );
};
